import React from "react";
import {StepNavItem} from "./StepNavItem";

interface StepNavProps {
  currentStep: number;
}

export const StepNav = (props: StepNavProps) => {
  const { currentStep } = props;

  return (
    <div className="flex justify-between">
      <StepNavItem
        {...{
          step: 1,
          stepName: '基本情報',
          currentStep,
        }}
      />
      <StepNavItem
        {...{
          step: 2,
          stepName: '3D空間',
          currentStep,
        }}
      />
      <StepNavItem
        {...{
          step: 3,
          stepName: 'VH定義',
          currentStep,
        }}
      />
      <StepNavItem
        {...{
          step: 4,
          stepName: 'メニューセット',
          currentStep,
        }}
      />
      <StepNavItem
        {...{
          step: 5,
          stepName: '参加者',
          currentStep,
        }}
      />
    </div>
  )
}